import React, { useState, useEffect } from 'react';

import UIList from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Paper from '@material-ui/core/Paper';
import { ExpandMoreRounded } from '@material-ui/icons';
import { RouteComponentProps } from '@reach/router';

import { IEventEnrollment } from '../../../store/player/events/store';

import Button from '../../../components/Button';
import Modal from '../../../components/Modal';
import GroupLookup from '../EventHome/GroupLookup/GroupLookup';
import PlayerLookup from '../EventHome/PlayerLookup/PlayerLookup';
import { useGetPlayerEvent } from '../../../contrib/Hooks/useGetPlayerEvent';
import { IComponentsLabelMap } from '../../common/Utils/IComponentsLabelMap';
import useLocation from '../../../contrib/Hooks/useLocation.hook';

interface IProps extends RouteComponentProps {
  clubId: string;
  eventId: string;
}

const EventStandings = (props: IProps) => {
  const { eventId, clubId } = props;

  const { location } = useLocation();

  const [isOpen, toggleOpen] = useState(false);
  const [direction, setDirection] = useState('');
  const [activeTab, setActiveTab] = useState(0);
  const [leaveTab, setLeaveTab] = useState(0);
  const [eventRounds, setEventRounds] = useState<IComponentsLabelMap[]>([]);
  const [steps, setSteps] = useState<IComponentsLabelMap[]>([]);
  const [eventEnrollments, setEventEnrollments] = useState<IEventEnrollment[]>([]);

  const event = useGetPlayerEvent(eventId);

  useEffect(() => {
    if (location.search.includes('teesheet')) {
      setActiveTab(1);
    }
  }, [location]);

  useEffect(() => {
    if (event && event.enrollments) {
      setEventEnrollments(event.enrollments);
    }
  }, [event]);

  useEffect(() => {
    if (event) {
      const newEventRounds: IComponentsLabelMap[] = event.rounds.map((round, index) => ({
        content: <GroupLookup event={event} roundId={String(round.id)} />,
        label: `PAIRING SHEET ROUND ${index + 1}`
      }));

      setEventRounds(newEventRounds);
    }
  }, [event, eventId]);

  useEffect(() => {
    const newSteps = [
      {
        content: (
          <PlayerLookup
            invertFiltersOrder={true}
            invitedFilterLabel="INVITED"
            registeredFilterLabel="REGISTERED"
            enrollments={eventEnrollments}
            clubId={Number(clubId)}
            eventId={eventId}
          />
        ),
        label: 'PLAYER FIELD'
      },
      ...eventRounds
    ];

    setSteps(newSteps);
  }, [eventEnrollments, eventRounds, clubId]);

  const setTab = (activeTabId: number) => () => {
    const leaveTabId = activeTab;

    if (leaveTabId !== activeTabId) {
      setDirection(leaveTabId < activeTab ? 'ltr' : 'rtl');
      setActiveTab(activeTabId);
      setLeaveTab(leaveTabId);
    }

    toggleOpen(false);
  };

  return (
    <div>
      <div className="home club-home event-standings">
        <Paper className="paper-full-width">
          {steps.length > 0 && steps[activeTab] && (
            <Button onClick={() => toggleOpen(!isOpen)} className="season-select">
              {steps[activeTab].label}

              <ExpandMoreRounded className="arrow-down" color="primary" />
            </Button>
          )}

          <div className={`slider ${direction} `}>
            {steps.map(({ content }, index) => (
              <div
                key={`club-settings-step-${index}`}
                className={`slide top admin-wrapper club-settings ${
                  activeTab === index ? 'active' : ''
                } ${leaveTab === index ? 'leave' : ''}`}
              >
                {content}
              </div>
            ))}
          </div>
        </Paper>

        <Modal
          onClose={() => toggleOpen(!isOpen)}
          className="player-scope"
          open={isOpen}
          title="FIELD"
        >
          <UIList className="select-list">
            {steps.map((option, index) => (
              <ListItem
                className="select-item"
                button={true}
                onClick={setTab(index)}
                id={`option-${index}`}
                key={`option-${index}`}
              >
                <ListItemText primary={option.label} />
              </ListItem>
            ))}
          </UIList>
        </Modal>
      </div>
    </div>
  );
};

export default EventStandings;
